import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import * as UiIcons from "@dcl/icons/esm/ui";
import ChevronRight from "@dcl/icons/esm/ui/chevron-right";
import SocialX from "@dcl/icons/esm/ui/social-x";
import OpenInNewTab2 from "@dcl/icons/esm/ui/open-in-new-tab-2";

var NavItem = function NavItem(_ref) {
  var title = _ref.title,
      href = _ref.href,
      iconName = _ref.iconName,
      iconPosition = _ref.iconPosition,
      target = _ref.target,
      ariaLabel = _ref.ariaLabel;
  var getClassName = getClassNameFactory("SiteFooterNavItem");
  var icons = {
    chevron: /*#__PURE__*/React.createElement(ChevronRight, null),
    x: /*#__PURE__*/React.createElement(SocialX, null),
    linkedin: /*#__PURE__*/React.createElement(UiIcons.SocialLinkedin, {
      width: 16
    }),
    instagram: /*#__PURE__*/React.createElement(UiIcons.SocialInstagram, {
      width: 16
    }),
    facebook: /*#__PURE__*/React.createElement(UiIcons.SocialFacebook, {
      width: 16
    }),
    youtube: /*#__PURE__*/React.createElement(UiIcons.SocialYoutube, {
      width: 16
    }),
    newtab: /*#__PURE__*/React.createElement(OpenInNewTab2, {
      size: 14
    })
  };
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "link"
    }),
    href: href,
    target: target,
    "data-icon-name": iconName,
    "data-icon-position": iconPosition,
    "aria-label": ariaLabel
  }, iconName && iconName !== "none" && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "icon"
    })
  }, icons[iconName]), title, target && target === "_blank" && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "new-tab-icon"
    })
  }, icons.newtab)));
};

NavItem.displayName = "SiteFooter.NavItem";
export default NavItem;